/* Bull Tallow Theme JS */
(function() {
  'use strict';

  /* Reveal-on-scroll animations */
  function initRevealAnimations() {
    var reveals = document.querySelectorAll('.reveal');
    if (!reveals.length) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    reveals.forEach(function(el) {
      observer.observe(el);
    });
  }

  /* Quantity selector */
  function initQuantitySelectors() {
    document.querySelectorAll('.quantity-selector').forEach(function(selector) {
      var input = selector.querySelector('input');
      var minus = selector.querySelector('[data-action="minus"]');
      var plus = selector.querySelector('[data-action="plus"]');

      if (minus) {
        minus.addEventListener('click', function() {
          var val = parseInt(input.value, 10);
          if (val > 1) {
            input.value = val - 1;
            input.dispatchEvent(new Event('change'));
          }
        });
      }

      if (plus) {
        plus.addEventListener('click', function() {
          var val = parseInt(input.value, 10);
          input.value = val + 1;
          input.dispatchEvent(new Event('change'));
        });
      }
    });
  }

  /* Mobile menu toggle */
  function initMobileMenu() {
    var toggle = document.querySelector('.header__menu-toggle');
    var nav = document.querySelector('.header__nav');
    if (!toggle || !nav) return;

    toggle.addEventListener('click', function() {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', !expanded);
      nav.classList.toggle('active');
      document.body.classList.toggle('menu-open');
    });
  }

  /* Product form - Add to cart */
  function initProductForms() {
    document.querySelectorAll('form[action="/cart/add"]').forEach(function(form) {
      form.addEventListener('submit', function(e) {
        var submitBtn = form.querySelector('[type="submit"]');
        if (submitBtn) {
          submitBtn.textContent = 'Adding...';
          submitBtn.disabled = true;
        }
      });
    });
  }

  /* Init all */
  document.addEventListener('DOMContentLoaded', function() {
    initRevealAnimations();
    initQuantitySelectors();
    initMobileMenu();
    initProductForms();
  });
})();
